import type { TypePolicies } from '../../utils/types/TypePolicies';
import { ANNOTATION_STATE_DEFAULTS, state } from './state';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      getAnnotationState: (_, { variables }) => {
        const { annotationId } = (variables ?? {}) as { annotationId?: string };
        if (!annotationId) return null;

        if (state.drafts.has(annotationId)) {
          return state.drafts.get(annotationId);
        }

        const newAnnotationState = {
          ...ANNOTATION_STATE_DEFAULTS,
          id: annotationId,
        };

        state.drafts.set(annotationId, newAnnotationState);

        return newAnnotationState;
      },
    },
  },
};
